import React from 'react';
import { Box } from '@mui/material';
import PatientDemographicForm from 'pages/Dashboard/components/PatientDempgraphicForm';
import PatientInviteForm from 'pages/Dashboard/components/PatientInviteForm';
import PatientInfoFormHeader from 'pages/Dashboard/components/PatientInfoFormHeader';
import { ToastProps } from 'components/Common/Toast';

export interface PatientInfoFormProps {
  isDemographicForm: boolean;
  addPatientWithoutInvite: boolean;
  setIsDemographicForm: (value: boolean) => void;
  setIsMinor?: (isMinor: boolean) => void;
  onSuccess?: (value: React.SetStateAction<boolean>) => void;
  setUploadToastProps?: React.Dispatch<React.SetStateAction<ToastProps | null>>
}

export default function PatientInfoForm({
  isDemographicForm,
  addPatientWithoutInvite,
  setIsDemographicForm,
  setIsMinor,
  onSuccess,
  setUploadToastProps,
}: PatientInfoFormProps) {
  return (
    <Box>
      <PatientInfoFormHeader
        isDemographicForm={isDemographicForm}
        setIsDemographicForm={setIsDemographicForm}
        onSuccess={onSuccess}
        setUploadToastProps={setUploadToastProps}
      />
      {isDemographicForm ? (
        <PatientDemographicForm
          addPatientWithoutInvite={addPatientWithoutInvite}
          setIsMinor={setIsMinor}
        />
      ) : (
        <PatientInviteForm />
      )}
    </Box>
  );
}
